export enum ApplicantRole {
    Primary = 'Primary',
    Spouse = 'Spouse',
    Child = 'Child',
}

export interface Applicant {
    index: string;
    dob: string;
    age: number;
    type: ApplicantRole;
    firstName?: string;
    lastName?: string;
}
